// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import DragController from "./drag_controller"
application.register("drag", DragController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import LinkController from "./link_controller"
application.register("link", LinkController)